<template>
  <div class="p-share-list">
    <div class="p-share-head">
      <!-- <HeaderSearch class="header-search" @focu="handleSearch" /> -->
      <SwitchBar title="分享" />
      <nav class="nav">
        <div :class="{active: feedType === 'new'}" @click="feedType = 'new'"> {{ $t('newest') }} </div>
        <div :class="{active: feedType === 'hot'}" @click="feedType = 'hot'"> {{ $t('hot') }} </div>
        <div :class="{active: feedType === 'follow'}" @click="feedType = 'follow'"> {{ $t('follow.name') }} </div>
        <div :class="{active: feedType === 'excellent'}" @click="feedType = 'excellent'"> 精华 </div>
      </nav>
    </div>

    <main class="feed-main">
      <JoLoadMore
        ref="loadmore"
        @onRefresh="onRefresh"
        @onLoadMore="onLoadMore"
      >
        <!-- 热门动态顶部 banner 广告位 -->
        <BannerAd
          v-if="feedType === 'hot'"
          type="feed:hot"
        />
        <ul v-gif-play class="feed-list">
          <li
            v-for="(feed, index) in pinned"
            v-if="feed.id"
            :key="`pinned-feed-${feedType}-${feed.id}-${index}`"
            :data-feed-id="feed.id"
          >
            <FeedCard
              :feed="feed"
              :pinned="true"
              :excellent="!!feed.excellent_at"
            />
          </li>
          <li
            v-for="(card, index) in feeds"
            :key="`feed-${feedType}-${card.id}-${index}`"
            :data-feed-id="card.id"
          >
            <FeedCard
              v-if="card.user_id"
              :feed="card"
              :excellent="!!card.excellent_at"
            />
            <!-- <FeedAdCard v-if="card.space_id" :ad="card" /> -->
          </li>
        </ul>
      </JoLoadMore>
    </main>
    <FootGuide />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { limit } from '@/api'
  import FeedCard from '@/components/FeedCard/FeedCard.vue'
  // import FeedAdCard from './components/FeedAdCard.vue'
  import BannerAd from '@/components/advertisement/BannerAd.vue'

  import SwitchBar from '../question/components/SwitchBar'

  const feedTypesMap = ['new', 'hot', 'follow', 'excellent']

  export default {
    name: 'FeedList',
    components: { FeedCard, BannerAd, SwitchBar },
    data () {
      return {
        key: '',
      }
    },
    computed: {
      ...mapGetters('feed', ['hot', 'new', 'follow', 'pinned', 'excellent']),
      feeds () {
        return this[this.feedType]
      },
      feedType: {
        get () {
          return this.$route.query.type || 'new'
        },
        set (val) {
          const { query } = this.$route
          this.$router.replace({ query: { ...query, type: val } })
        },
      },
      after () {
        const len = this.feeds.length
        if (!len) return 0
        if (this.feedType !== 'hot') return this.feeds[len - 1].id // after
        return this.feeds[len - 1].hot // offset
      },
    },
    watch: {
      feedType (val) {
        if (feedTypesMap.includes(val)) {
          this.$refs.loadmore.beforeRefresh()
        }
      },
    },
    created () {
      this.$store.dispatch('feed/getAdvertise')
      this.$nextTick(() => {
        this.$refs.loadmore.beforeRefresh()
      })
    },
    activated () {
      if (this.$route.query.refresh) {
        this.$refs.loadmore.beforeRefresh()
      }
    },
    methods: {
      async onRefresh () {
        const type = this.feedType.replace(/^\S/, s => s.toUpperCase())
        const action = `feed/get${type}Feeds`
        let data
        try {
          data = await this.$store.dispatch(action, { refresh: true, key: this.key })
          this.$refs.loadmore.afterRefresh(data.length < limit)
        } catch (error) {
          this.$refs.loadmore.afterRefresh()
        }
      },
      async onLoadMore () {
        const type = this.feedType.replace(/^\S/, s => s.toUpperCase())
        const action = `feed/get${type}Feeds`
        const data = await this.$store.dispatch(action, { after: this.after, key: this.key })
        this.$refs.loadmore.afterLoadMore(data.length < limit)
      },
      handleSearch (key) {
        this.$router.push({
          path: 'search_list?type=share',
        })
      },
    },
  }
</script>

<style lang="less" scoped>
.p-share-list {
  padding-bottom: 100px;
  min-height: 100vh;
  .p-share-head {
    position: sticky;
    top: 0;
    z-index: 99;
  }
  .nav {
    position: fixed;
    top: 90px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    max-width: 768px;
    height: 70px;
    background: #fff;
    color: #999;
    font-size: 30px;
    border-bottom: solid 1px #dedede; /* no */
    z-index: 10;
    font-weight: bold;
    padding-top: 5px;

    > div {
      color: #999;
      height: 65px;
      line-height: 65px;
    }

    .active {
      color: #333;
     border-bottom: 4px solid @tool-bar-bg;
    }
  }
  .feed-list {
    background-color: @gray-bg;
    li {
      margin-bottom: 15px;
    }
  }
  .header-search {
    position: fixed;
    width: 100%;
    height: 88px;
    // max-width: 768px;
    background-color: @tool-bar-bg;
    // padding-top: 28px;
    // display: flex;
    // align-items: center;
    z-index: 10;
    position: absolute;
    padding-top: 17px;
    width: 100%;
  }
  .feed-main {
    padding-top: 160px;
  }
}
</style>

<style scoped>
.header >>> .title {
  width: 100%;
}
.p-share-head >>> .c-switch-bar{
  top: 0;
}
</style>
